<template>
  <div>
    <van-cell-group title="审批人" border size="large">
      <div class="approvers">
          <van-row type="flex" justify="center" class="approver">
            <van-col span="9" v-if='flow.user'>
              <van-image
                round
                width="3rem"
                height="3rem"
                :src="flow.user.thumb_avatar"
              />
              <h3>{{flow.name}}<mu-badge content="发起人" color="secondary"></mu-badge></h3>
              <p>{{flow.position}}</p>
              
              </van-col>
              <van-col span="9">
              <van-notice-bar wrapable color="#1989fa" background="#ecf9ff" left-icon="passed">
                发起时间<br>{{flow.created_at}}
              </van-notice-bar>
              
            </van-col>

          </van-row>
          
        <van-divider />
        </div>
      <div class="approvers" v-for="(items,index) in flow.apprvoers" :key="index">
          <van-row type="flex" justify="center" class="approver" v-for="approver in items" :key="approver.id">
            <van-col span="9">
              <van-image
                round
                width="3rem"
                height="3rem"
                :src="approver.thumb_avatar"
              />
              <h3>{{approver.name}}<mu-badge :content="approver.role" color="secondary"></mu-badge></h3>
              <p>{{approver.position}}</p>
              <p v-if="approver.operate_user">由{{approver.operate_user.name}}于{{approver.created_at}}加签</p>
              <p v-if="approver.add_reason">加签原因：{{approver.add_reason}}</p>
              </van-col>
              <van-col span="9">
              <van-notice-bar wrapable v-if="approver.status == 1" color="#1989fa" background="#ecf9ff" left-icon="passed">
                审核通过<span v-show="approver.comment"><br>{{approver.comment}}</span><br>{{approver.approval_at}}
              </van-notice-bar>
              <van-notice-bar wrapable v-if="approver.status == 2" color="#ff0000" background="#ecf9ff" left-icon="close">
                审核拒绝<span v-show="approver.comment"><br>{{approver.comment}}</span><br>{{approver.approval_at}}
              </van-notice-bar>
            </van-col>

          </van-row>
          
        <van-divider />
        </div>
        <!--添加审批人 -->
        <div>
          <van-row type="flex" justify="center" class="add_button" v-if="flow.role==2||flow.role==1||flow.role==22">
            <van-col span="8">
              <van-button icon="plus" type="primary" @click="openUserModel()" round native-type="button">加签</van-button>
            </van-col>
          </van-row>

        </div>
        
        
      
  </van-cell-group>
  <!-- <van-popup  position="bottom" v-model="user.show">
    <van-search placeholder="请输入用户姓名" v-model="userForm.user" @input="getUser()"/>
    <van-picker 
      cancel-button-text='取消' 
      value-key="name"    
      show-toolbar 
      :columns="user.data"  
      @confirm="addApprover"
      @cancel="user.show = false"
  />
  </van-popup> -->
  <mu-dialog transition="slide-bottom" fullscreen lock-scroll scrollable :open.sync="user.show">
    <mu-paper :z-depth="1" class="demo-list-wrap">
      <div class="user_top">
        <mu-appbar color="indigo500">
          通讯录
          <mu-button icon slot="right">
            <!-- <mu-icon :value="close"></mu-icon> -->
            <van-icon name="close" @click="user.show = false" />
          </mu-button>
        </mu-appbar>
        
        <van-search placeholder="请输入用户姓名" v-model="userForm.user" @input="getUser()"/>
      </div>
      <div class="user_content">
        <mu-list v-for="(items,key) in user.data" :key="key">
          <mu-sub-header>{{key}}</mu-sub-header>
          <mu-list-item avatar button :ripple="false" v-for="item in items" :key="item.userid" @click="addApprover(item)">
            <mu-list-item-action>
              <mu-avatar>
                <img :src="item.thumb_avatar">
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-title>{{item.name}}</mu-list-item-title>
            <mu-list-item-sub-title>{{item.position}}</mu-list-item-sub-title>
            <!-- <mu-list-item-action>
              <mu-icon :value="item.position"></mu-icon>
            </mu-list-item-action> -->
          </mu-list-item>
          <mu-divider></mu-divider>
        </mu-list>
      </div>
    </mu-paper>
  </mu-dialog>
    
  </div>
</template>

<script>
export default {
  name: 'Approver',
  props: {
    flow:Object,
    users:Object,
  },
  data(){
    return{
      approvers:[],
      user:{
        show:false,
        data:this.users,
      },
      userForm:{
        user:'',
      },
      addApproverForm:{

      },
    }
  },
  created(){
    

  },
  methods:{
    openUserModel(){
      // this.getUser();
      this.user.show=true;
    },
    getUser(){
      this.$http.post('get_users',this.userForm)
      .then((res)=>{
        console.log(res)
        this.user.data = res.data.data
      })

    },
    removeApprover(x,y){
      console.log(x,y);
      this.approvers[x].splice(y,1)
      if(this.approvers[x].length ==0){
        this.approvers.splice(x,1)
      }
      console.log(this.approvers)
    },

    addApprover(user){
      this.addApproverForm.user = user
      this.addApproverForm.flow_id = this.flow.id
      this.$prompt(
        '请输入加签原因','确定添加审批人：'+user.name+'?',{
        validator (value) {
          return {
            valid: !!value,
            message: '请输入加签原因！'
          }
        }
      })
      .then(({result,value})=>{
        if(!result){
          return false;
        }
        this.user.show = false;
        this.userForm.user ='';
        this.addApproverForm.add_reason = value;
        this.$http.post('flow/add_approver',this.addApproverForm)
        .then((res)=>{
          console.log(res)
          if(res.data.code !=200){
            this.$dialog.alert({
              message: res.data.msg,
            })
            return false;
          }
          this.$dialog.alert({
            message: res.data.msg,
          })
          .then((res)=>{
            location.reload()
          })
        })
      })

    },
    

  },
  watch:{
    users:function(val){
      this.user.data = val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
.van-cell__title{
  text-align:left;

}
h3 {
  font-size:12px;
}
p{
  margin:0px;
  font-size:12px;
}

.van-notice-bar{
  padding:5px 0;
  margin-top:15px;
}
.add_button{
  margin:10px 0px;
}
.van-popup__close-icon {
    position: fixed;
    z-index: 99;
    color: #c8c9cc;
    font-size: 22px;
    cursor: pointer;
}

.user_top{
  position:fixed;
  top:0px;
  width:100%;
  z-index:2;
}
.user_content{
  margin-top:110px;
}
.mu-list-item{
  display:block;
}
</style>
<style>
/* .mu-dialog-wrapper, .mu-dialog, .mu-dialog-body{
  max-height:none !important;
} */
.mu-dialog-fullscreen .mu-dialog-body {
    padding: 0;
    max-height: 1200px !important;
}
  
</style>
